export default __webpack_public_path__ + "static/media/problema-04.9250e941.webp";